import React from 'react';

/** Always-visible dropdown: which bot this page is configuring. Every bot of the workspace is listed. */
export default function BotSwitcher({ bots, botId, onChange, label = 'Bot being configured' }) {
  if (!bots || bots.length === 0) return null;
  return (
    <div className="d-flex flex-wrap align-items-center gap-2 mb-3 p-2 border rounded bg-white" data-testid="bot-switcher">
      <label htmlFor="active-bot" className="small fw-semibold mb-0 ms-1"><i className="bi bi-robot me-1" aria-hidden="true" />{label}</label>
      <select id="active-bot" className="form-select form-select-sm w-auto" style={{ minWidth: 220 }} value={botId || ''} onChange={(e) => onChange(e.target.value)}>
        {bots.map((b) => <option key={b.id} value={b.id}>{b.name} — {b.status === 'active' ? 'Active' : 'Inactive'} (v{b.version})</option>)}
      </select>
    </div>
  );
}
